import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-OAuth2',
    templateUrl: './OAuth2.component.html'
})
export class OAuth2Component implements OnInit {

    consumerID: string;
    scopes: [];
    mandatory_scope = false;
    provisionKey: any;
    token_expiration = 7200;
    enable_authorization_code = false;
    enable_implicit_grant = false;
    enable_client_credentials = false;
    enable_password_grant = false;
    hide_credentials = false;
    accept_http_if_already_terminated = false;
    anonymous: string;
    global_credentials = false;
    auth_header_name = 'authorization';
    refresh_token_ttl = 1209600;

    data = {
        'consumerID' : this.consumerID,
        'scopes' : this.scopes,
        'mandatory_scope' : this.mandatory_scope,
        'token_expiration' : this.token_expiration,
        'enable_authorization_code' : this.enable_authorization_code,
        'enable_implicit_grant' : this.enable_implicit_grant,
        'enable_client_credentials' : this.enable_client_credentials,
        'enable_password_grant' : this.enable_password_grant,
        'hide_credentials' : this.hide_credentials,
        'accept_http_if_already_terminated' : this.accept_http_if_already_terminated,
        'anonymous' : this.anonymous,
        'global_credentials' : this.global_credentials,
        'auth_header_name' : this.auth_header_name,
        'refresh_token_ttl' : this.refresh_token_ttl,
        'plugin' : 'oauth2'
    }

    constructor() { }
    slider() {
        this.mandatory_scope = !this.mandatory_scope;
    }
    slider1() {
        this.enable_authorization_code = !this.enable_authorization_code;
    }
    slider2() {
        this.enable_implicit_grant = !this.enable_implicit_grant;
    }
    slider3() {
        this.enable_client_credentials = !this.enable_client_credentials;
    }
    slider4() {
        this.enable_password_grant = !this.enable_password_grant;
    }
    slider5() {
        this.hide_credentials = !this.hide_credentials;
    }
    slider6() {
        this.accept_http_if_already_terminated = !this.accept_http_if_already_terminated;
    }
    slider7() {
        this.global_credentials = !this.global_credentials;
    }

    setOAuth2() {
    }

    ngOnInit() {
    }

}
